import { FC } from 'react';
import { FormControl } from 'react-bootstrap';
import { connect, useForm } from 'react-bootstrap-formutil';
import FormGroup from 'components/FormGroup';
import CountrySelect from 'components/forms/CountrySelect';
import Email from 'components/forms/Email';
import FirstName from 'components/forms/RealNameInfo/components/FirstName';
import LastName from 'components/forms/RealNameInfo/components/LastName';
import MiddleInitial from 'components/forms/RealNameInfo/components/MiddleInitial';
import TelcodesPhone from 'components/forms/TelcodesPhone';
import UsStatesSelect from 'components/UsStatesSelect';
import { CountryTypeEnum } from 'types/common';
import { printf } from 'utils/i18n';
import patterns from 'utils/patterns';
import { TrustedContactPersonDataItem } from '../type';

// 受信联系人信息-表单内容 https://tigertech.feishu.cn/wiki/HBoDws68riyoaqkLQKrcYmgpnUk
const ContactPersonContent: FC<{
    isSSN: boolean;
    data?: TrustedContactPersonDataItem;
}> = ({ isSSN, data }) => {
    const { phone: originPhone, email: originEmail } = data || {};
    const {
        $params: { country }
    } = useForm();

    return (
        <>
            {/* 中英文名字都可以 */}
            <FirstName
                label={__('Label:名')}
                placeholder={__('Label:名')}
                checker={value => {
                    if (!value) {
                        return printf(__('Please enter the %s'), __('Label:名'));
                    }

                    return true;
                }}
            />
            <MiddleInitial />
            <LastName
                label={__('Label:姓')}
                placeholder={__('Label:姓')}
                checker={value => {
                    if (!value) {
                        return printf(__('Please enter the %s'), __('Label:姓'));
                    }

                    return true;
                }}
            />
            <TelcodesPhone
                label={__('Phone Number')}
                phoneOptions={{
                    checker: value => {
                        if (!value) {
                            return printf(__('Please enter the %s'), __('Phone Number'));
                        }

                        // 没有原始值或者发生修改后校验格式，因为server返回的是脱敏数据，且认为提交带有掩码等于未修改
                        if ((!originPhone || value !== originPhone) && !patterns.isPhone(value)) {
                            return __('Please enter a valid phone number');
                        }

                        return true;
                    }
                }}
            />
            <Email
                label={__('Email Address')}
                checker={value => {
                    if (!value) {
                        return printf(__('Please enter the %s'), __('Email Address'));
                    }

                    // 没有原始值或者发生修改后校验格式，因为server返回的是脱敏数据，且认为提交带有掩码等于未修改
                    if ((!originEmail || value !== originEmail) && !patterns.isUsEmail(value)) {
                        return __('Invalid e-mail address');
                    }

                    return true;
                }}
            />
            <FormGroup
                name="relationship"
                label={__('关系名称')}
                checker={value => {
                    if (!value) {
                        return printf(__('Please enter the %s'), __('关系名称'));
                    }

                    return true;
                }}>
                <FormControl placeholder={__('关系名称')} />
            </FormGroup>
            <h5>{__('Residential Address')}</h5>
            <FormGroup
                label={__('Country')}
                name="country"
                checker={value => {
                    if (!value) {
                        return printf(__('Please select the %s'), __('Country'));
                    }

                    return true;
                }}>
                <CountrySelect isSSN={isSSN} type={CountryTypeEnum.TRUSTED_CONTACT_PERSON} />
            </FormGroup>
            <FormGroup
                name="home_address"
                label={__('Address#1')}
                checker={value => {
                    if (!value) {
                        return printf(__('Please enter the %s'), __('Address#1'));
                    }

                    return true;
                }}>
                <FormControl placeholder={__('Address#1')} />
            </FormGroup>
            <FormGroup name="home_address2" label={__('Address#2(Optional)')}>
                <FormControl placeholder={__('Address#2(Optional)')} />
            </FormGroup>
            <FormGroup
                name="home_city"
                label={__('City')}
                checker={value => {
                    if (!value) {
                        return printf(__('Please enter the %s'), __('City'));
                    }

                    return true;
                }}>
                <FormControl placeholder={__('City')} />
            </FormGroup>
            <FormGroup
                label={__('State/Province')}
                name="home_state_code"
                checker={value => {
                    if (!value) {
                        return printf(__('Please enter the %s'), __('State/Province'));
                    }

                    return true;
                }}>
                {country === 'USA' ? <UsStatesSelect /> : <FormControl placeholder={__('State/Province')} />}
            </FormGroup>
        </>
    );
};

export default connect(ContactPersonContent);
